import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { getCommunityNearbyListingsInfo } from 'constants/routes'

/**
 * Retrieves additional information for a community summary card.
 * @param {Object} payload - The payload containing the community id.
 * @returns {Observable} - An observable that emits the additional marker information.
 */
function getCommunityNearbyListings(payload) {
  const url = `${getCommunityNearbyListingsInfo}?ids=${payload.communityIds}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'image/webp',
    }
  }).pipe(
    switchMap((response) => response.json())
  );
}

export default getCommunityNearbyListings;